module.exports = __webpack_public_path__ + "img/hr-cliff-outer-shadow.82971148.png";